module.exports = __webpack_public_path__ + "img/bathrooms.f468bb32.svg";